import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TutorialState {
  hasCompletedTutorial: boolean;
  tutorialStep: number;
  isTutorialActive: boolean;
  setHasCompletedTutorial: (completed: boolean) => void;
  setTutorialStep: (step: number) => void;
  setIsTutorialActive: (active: boolean) => void;
  resetTutorial: () => void;
}

export const useTutorialStore = create<TutorialState>()(
  persist(
    (set) => ({
      hasCompletedTutorial: false,
      tutorialStep: 0,
      isTutorialActive: false,
      setHasCompletedTutorial: (completed) =>
        set({ hasCompletedTutorial: completed }),
      setTutorialStep: (step) => set({ tutorialStep: step }),
      setIsTutorialActive: (active) => set({ isTutorialActive: active }),
      resetTutorial: () =>
        set({
          hasCompletedTutorial: false,
          tutorialStep: 0,
          isTutorialActive: false,
        }),
    }),
    {
      name: 'tutorial-storage',
    },
  ),
);
